import { UserContext } from "@context/User/UserContext";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

/**
 * Hook to calculate header height dynamically based on user subscription status
 * and device type (mobile/desktop).
 *
 * @returns Object with desktop and mobile header heights
 */
export const useHeaderHeight = () => {
  const theme = useTheme();
  const userCtx = React.useContext(UserContext);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const isSubscriber = Boolean(userCtx?.isSubscriber);
  const hasPromoBanner =
    Boolean(userCtx?.user?.email && userCtx.user.email.trim() !== "") &&
    !isSubscriber;

  // Base heights from theme
  const appBarHeight = "64px"; // theme.customLayoutHeight.appNavBarHeight = "4rem" = 64px
  const safeAreaMin = theme.customLayoutHeight.mobileSafeAreaMin; // "20px"

  // Calculate heights
  const baseHeight = hasPromoBanner
    ? theme.customLayoutHeight.appBarAndBannerHeight // "104px"
    : appBarHeight; // "64px"

  const desktopHeight = baseHeight;
  const mobileHeight = `calc(${baseHeight} + max(env(safe-area-inset-top, 0px), ${safeAreaMin}))`;

  return {
    desktop: desktopHeight,
    mobile: mobileHeight,
    current: isMobile ? mobileHeight : desktopHeight
  };
};
